import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
import profLeandro from "@/assets/orto/prof-leandro.jpg.asset.json";

const TITLE = "Pós em Fisioterapia em Traumatologia | Versão A | FEO";
const DESC =
  "Versão A da LP: pós online em Fisioterapia em Traumatologia. 14 módulos, 360h, MEC. Pré, pós-operatório e reabilitação cirúrgica com base em evidência.";
const URL = "https://fisioemortopedia.com.br/trauma1";

export const Route = createFileRoute("/trauma1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: TraumaLP1,
});

function TraumaLP1() {
  return (
    <PosFigmaLP
      product="trauma"
      heroBadge="Pós-Graduação 100% online"
      heroTitle={["Fisioterapia", "em Traumatologia", "do pré ao pós-cirúrgico"]}
      heroSubtitle="Conduza o paciente cirúrgico com clareza, da preparação pré-operatória ao retorno funcional, com protocolos baseados em evidências."
      coordenadorNome="Leandro Fukusawa"
      coordenadorFoto={profLeandro.url}
      coordenadorBio="Coordenador da pós em Fisioterapia em Traumatologia da FEO. Especialista em reabilitação musculoesquelética e pós-cirúrgica, com mais de 15 anos de prática clínica e ensino, e produção científica indexada."
      ementaSubtitle="Baixe o PDF com a grade completa dos módulos, os professores e o cronograma das aulas da pós em Traumatologia."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
